import styles from './DropdownCard.module.scss';
import { Text } from '../typography';
import Icon from '../Icon';
import { useTranslation } from 'react-i18next';
import { customColors } from '../../utilities';
import classNames from 'classnames';
import TextWithIcon from '../typography/TextWithIcon';

export default function DropdownCard(props) {
  const {
    img = null,
    title,
    size = 'sm',
    weight,
    icon = null,
    iconProps = { fontSize: '1.2rem' },
    shared = false,
    smallText = '',
    onClick = () => {},
    readOnly = true,
    xSmallText = '',
    smallIcon = '',
    xSmallIcon = '',
  } = props || {};

  const { t } = useTranslation();

  const iconStyle = smallText
    ? { ...iconProps, fontSize: '1.5rem' }
    : iconProps;

  return (
    <div className={classNames([styles.container, styles[size]])}>
      {!img ? (
        icon ? (
          <Icon style={iconStyle}>{icon || 'star_outlined'}</Icon>
        ) : null
      ) : (
        <img
          className={!!smallText ? styles.avatarmd : styles[`avatar${size}`]}
          alt="avatar"
          src={img}
        />
      )}
      <div className={styles.textContent}>
        <Text
          noMargin
          truncate
          hover={!readOnly}
          size={smallText ? 'sm-md' : size || 'md'}
          weight={weight || 'semiBold'}
          onClick={onClick}
          className={!readOnly ? styles.link : undefined}
        >
          {t(title) || title}
        </Text>
        {!!smallText && (
          <TextWithIcon
            leftIcon={smallIcon}
            icon={!!shared ? 'public' : null}
            iconProps={{
              color: customColors.BLUE,
              fontSize: '0.75rem',
              opacity: 0.7,
            }}
            noMargin
            size="sm"
            truncate
          >
            {smallText}
          </TextWithIcon>
        )}
        {!!xSmallText && (
          <TextWithIcon
            leftIcon={xSmallIcon}
            iconProps={{
              color: customColors.BLUE,
              fontSize: '0.75rem',
              opacity: 0.7,
            }}
            noMargin
            color="secondary"
            size="xs"
          >
            {xSmallText}
          </TextWithIcon>
        )}
      </div>
    </div>
  );
}
